import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";

export default function CartRedirect() {
  const navigate = useNavigate();
  const { openSidebar } = useCart();

  useEffect(() => {
    // Open the cart sidebar
    openSidebar();
    // Redirect to home page
    navigate("/", { replace: true });
  }, [navigate, openSidebar]);

  // Show nothing while redirecting
  return null;
}


